import {AppExposedApis, ComponentRef, EditorSDK, EventType} from '@wix/platform-editor-sdk';
import {EditorReadyFn, EditorScriptFlowAPI} from '@wix/yoshi-flow-editor';

import {
  handleAppInstalled,
  handleBeforeRemoveApp,
  handleOpenDashboard,
  handleOpenOnboarding,
  handleOpenPackagePicker,
  handleOpenTranslationAssistantPanel,
} from '@/handlers';

const TOKEN = ''; // editor platform said that it's unused and should be an empty string

export const editorReadyContext: {flowAPI: EditorScriptFlowAPI | undefined} = {
  flowAPI: undefined,
};

export const editorReady: EditorReadyFn = async (
  editorSDK,
  _token,
  {firstInstall, origin},
  flowAPI,
) => {
  editorReadyContext.flowAPI = flowAPI;
  flowAPI.panoramaClient?.transaction('editorReady').start();
  if (firstInstall) {
    flowAPI.panoramaClient?.transaction('editorReady_firstInstall').start();
  }

  const appInstance = await editorSDK.info.getAppInstance(_token);
  await editorSDK.addEventListener(EventType.appInstalled, () =>
    handleAppInstalled(editorSDK, flowAPI.panoramaClient, flowAPI.bi, origin.type, appInstance),
  );

  const editorSessionId = await editorSDK.editor.info.getEditorSessionId();
  const metaSiteId = await editorSDK.document.info.getMetaSiteId(TOKEN);
  flowAPI.bi?.updateDefaults({src: 89, msid: metaSiteId, esi: editorSessionId});

  if (firstInstall) {
    flowAPI.panoramaClient?.transaction('editorReady_firstInstall').finish();
  }
  flowAPI.panoramaClient?.transaction('editorReady').finish();
};

export const exports = (editorSDK: EditorSDK): AppExposedApis => {
  return {
    editor: {
      beforeRemoveApp: () => handleBeforeRemoveApp(editorSDK, TOKEN),
    },
    public: {
      openOnboarding: () => handleOpenOnboarding(editorSDK, TOKEN),
      openDashboard: (openDashboardPayload?: Record<string, any>) =>
        handleOpenDashboard(editorSDK, TOKEN, openDashboardPayload),
      openPackagePicker: (openPackagePickerPayload?: Record<string, any>) =>
        handleOpenPackagePicker(editorSDK, TOKEN, openPackagePickerPayload),
      openTranslationAssistantPanel: (componentRef: ComponentRef) =>
        handleOpenTranslationAssistantPanel(editorSDK, componentRef),
    },
  };
};
